import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/addressActions'
import * as api from '../api/address'

function* getCompanyAddresses(action) {
  try {
    const payload = yield call(api.getCompanyAddresses, action)
    yield put({ type: constants.GET_COMPANY_ADDRESSES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_COMPANY_ADDRESSES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetCompanyAddresses() {
  yield takeLatest(constants.GET_COMPANY_ADDRESSES.ACTION, getCompanyAddresses)
}

function* sagaCompanyCreateAddress(action) {
  try {
    const payload = {
      address: {
        company: action.companyId,
        address1: action.address.address1,
        address2: action.address.address2,
        city: action.address.city,
        state: action.address.state,
        zip: action.address.zip
      },
      user_id: action.userId
    }

    yield call(api.companyCreateAddress, payload)
    yield put({ type: constants.COMPANY_CREATE_ADDRESS.SUCCESS, payload })
    yield call(getCompanyAddresses, { companyId: action.companyId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.COMPANY_CREATE_ADDRESS.FAILED,
      message: e.message || e
    })
  }
}

function* watchCompanyCreateAddress() {
  yield takeLatest(constants.COMPANY_CREATE_ADDRESS.ACTION, sagaCompanyCreateAddress)
}

function* sagaCompanyUpdateAddress(action) {
  try {
    const payload = {
      address: {
        company: action.companyId,
        address1: action.address.address1,
        address2: action.address.address2,
        city: action.address.city,
        state: action.address.state,
        zip: action.address.zip
      },
      address_id: action.addressId,
      user_id: action.userId
    }

    yield call(api.companyUpdateAddress, payload)
    yield put({ type: constants.COMPANY_UPDATE_ADDRESS.SUCCESS, payload })
    yield call(getCompanyAddresses, { companyId: action.companyId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.COMPANY_UPDATE_ADDRESS.FAILED,
      message: e.message || e
    })
  }
}

function* watchCompanyUpdateAddress() {
  yield takeLatest(constants.COMPANY_UPDATE_ADDRESS.ACTION, sagaCompanyUpdateAddress)
}
function* sagaCompanyDeleteAddress(action) {
  try {
    const payload = {
      address_id: action.addressId
    }
    yield call(api.companyDeleteAddress, payload)
    yield put({ type: constants.COMPANY_DELETE_ADDRESS.SUCCESS, payload })
    yield call(getCompanyAddresses, { companyId: action.companyId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.COMPANY_DELETE_ADDRESS.FAILED,
      message: e.message || e
    })
  }
}

function* watchCompanyDeleteAddress() {
  yield takeLatest(constants.COMPANY_DELETE_ADDRESS.ACTION, sagaCompanyDeleteAddress)
}

function* sagaUpdateCompanyPrimaryAddress(action) {
  try {
    const payload = {
      address_id: action.addressId,
      company_id: action.companyId
    }
    yield call(api.updateCompanyPrimaryAddress, payload)
    yield put({ type: constants.UPDATE_COMPANY_PRIMARY_ADDRESS.SUCCESS, payload })
    yield call(getCompanyAddresses, { companyId: action.companyId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_COMPANY_PRIMARY_ADDRESS.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateCompanyPrimaryAddress() {
  yield takeLatest(constants.UPDATE_COMPANY_PRIMARY_ADDRESS.ACTION, sagaUpdateCompanyPrimaryAddress)
}

export function* rootSaga() {
  yield all([
    fork(watchGetCompanyAddresses),
    fork(watchCompanyCreateAddress),
    fork(watchCompanyDeleteAddress),
    fork(watchCompanyUpdateAddress),
    fork(watchUpdateCompanyPrimaryAddress)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/addressSaga.js